<template lang="html">

  <section class="oleoturismo row-center ais banner-child-vive animation" :id="$t('banners_experiencia.oleoturismo.id')">

    <div class="texto column-center">
      <div class="container -half">
        <h2 class="title -black" v-html="$t('banners_experiencia.oleoturismo.titulo')"></h2>
        <p v-html="$t('banners_experiencia.oleoturismo.cuerpo')"></p>
        <a class="imagen-trip" target="_blank" href="https://www.tripadvisor.es/Attraction_Review-g1437533-d15780377-Reviews-Bodegas_Aldonza-Munera_Province_of_Albacete_Castile_La_Mancha.html">
          <img src="/static/img/tripadvisor-negro.png" alt="" class="tripadvisor">
        </a>

      </div>
    </div>

    <div class="imagen">
      <article class="banner-oleoturismo row-center plum-border -white -xl">
        <router-link :to="$t('enlaces.oleoturismo')" class="enlace-cover"></router-link>
        <router-link :to="$t('enlaces.oleoturismo')" class="btn">
          <span v-html="$t('banners_experiencia.oleoturismo.boton')"></span>
        </router-link>
      </article>
    </div>

  </section>

</template>

<script lang="js">
 export default  {
  name: 'banner-oleoturismo',
}
</script>

<style scoped lang="scss">

@import "@/assets/css/colors.scss";

.oleoturismo{
  width: 100%;
  background: white;
}
.tripadvisor{
  max-width: 60px;
  padding-top:30px;
  float:center
}
p{
  text-align: justify;
}

.texto{
  background: white;
  color: black;
}

.title{
  color: black;
}

.oleoturismo > div{
  width: 50%;
}

@media screen and (max-width: 1023px){
  .oleoturismo > div{
  width: 100%;
  height: auto;
 padding: 50px 25px;
  &.texto{
    padding: 50px 0 0 0;
    order: -1;
  }
}
}

</style>



// WEBPACK FOOTER //
// src/components/parts/banner-oleoturismo.vue